import MarketingLayout from '../components/MarketingLayout';
import LegalPage from '../components/LegalPage';

export default function Privacy() {
  return (
    <MarketingLayout
      title="Privacy - 10X Planner App"
      description="Privacy policy for 10X Planner App."
      canonical="/privacy"
    >
      <LegalPage heading="Privacy Policy">
        <p>
          This privacy policy discloses the privacy practices for{' '}
          <a href="https://10xplannerapp.com">https://10xplannerapp.com</a>. It applies solely
          to information collected by this website.
        </p>
        <ul>
          <li>What personally identifiable information is collected from you through the website.</li>
          <li>How that information is used and with whom it may be shared.</li>
          <li>What choices are available to you regarding the use of your data.</li>
          <li>The security procedures in place to protect the misuse of your information.</li>
          <li>How you can correct inaccuracies in the information.</li>
        </ul>

        <h3>Information Collection, Use, and Sharing</h3>
        <p>
          We are the sole owners of the information collected on this site. We only collect
          information that you voluntarily give us via email, forms, account signup, or other
          direct contact. We will not sell or rent this information to anyone.
        </p>
        <p>
          We use your information to respond to you, operate the service, process billing, and
          provide support. We do not share your information with any third party outside of our
          organization other than as necessary to fulfill your request, such as processing payment
          through Stripe or sending transactional email.
        </p>
        <p>
          Unless you ask us not to, we may contact you by email in the future about service
          updates, new features, billing matters, or changes to this privacy policy.
        </p>

        <h3>Your Access to and Control Over Information</h3>
        <p>
          You may opt out of future non-transactional contacts from us at any time. You can also
          contact us to see what data we have about you, correct data we have about you, request
          deletion of your data, or express a concern about our use of your data.
        </p>

        <h3>Security</h3>
        <p>
          We take precautions to protect your information. Sensitive information is encrypted in
          transit using HTTPS. Access to personally identifiable information is limited to people
          and systems that need it to operate, support, and improve the service.
        </p>

        <h4>Credit Card Information</h4>
        <p>
          We do not store your credit card information directly. Payments are processed by Stripe.
          Stripe may provide us with billing metadata such as customer ID, subscription status,
          card brand, and last four digits so we can provide billing support.
        </p>

        <h3>Cookies and Analytics</h3>
        <p>
          We use cookies and similar technologies to keep you signed in, understand usage, and
          improve the product. We may use analytics services such as Google Analytics and Microsoft
          Clarity. If you do not want to be tracked by Google Analytics, you can use{' '}
          <a href="https://tools.google.com/dlpage/gaoptout/" target="_blank" rel="noreferrer">
            Google&apos;s official opt-out browser add-on
          </a>
          .
        </p>

        <h3>Customer Support Chat</h3>
        <p>
          We use Crisp to provide customer support through the chat widget on this website. If you
          use the widget, Crisp processes your messages and any contact information you choose to
          provide, and may use cookies or similar browser storage to maintain the conversation. See{' '}
          <a href="https://crisp.chat/en/privacy/" target="_blank" rel="noreferrer">
            Crisp&apos;s privacy policy
          </a>{' '}
          for more information.
        </p>

        <h3>Links</h3>
        <p>
          This website may contain links to other sites. We are not responsible for the content or
          privacy practices of those sites.
        </p>

        <h3>Updates</h3>
        <p>
          Our privacy policy may change from time to time. Updates will be posted on this page.
          Questions or concerns should be sent to{' '}
          <a href="mailto:10xplannerapp@gmail.com">10xplannerapp@gmail.com</a>.
        </p>
      </LegalPage>
    </MarketingLayout>
  );
}
